import React, {useEffect, useState} from 'react'
import LoadingIndicator from '../../Components/LoadingIndicator'
import {ConnectedProducersListBlockProps} from './types'
import CompanyInformations from '../../Services/CompanyInformations'
import {
    IConnectedProducersListResponse,
    PortalCustomerItem,
} from '../../Services/CompanyInformations/interfaces'
import {StatusCode} from '../../Services/Response.types'
import ProducersList from './ProducersList'
import ConnectedProducersListHeader from './ConnectedProducersListHeader'
import filter from 'lodash/filter'
import includes from 'lodash/includes'

const ConnectedProducersList = (props: ConnectedProducersListBlockProps) => {
    const [loading, setLoading] = useState<boolean>(false)
    const [producersList, setProducersList] = useState<PortalCustomerItem[]>([])
    const [filteredProducersList, setFilteredProducersList] = useState<
        PortalCustomerItem[]
    >([])

    const isSearched = !!(producersList.length > filteredProducersList.length)

    const fetchConnectedProducersList = () => {
        setLoading(true)
        const response: IConnectedProducersListResponse = {items: []}

        CompanyInformations.GetConnectedProducersList()
            .then(result => {
                if (result.status === StatusCode.OK) {
                    response.items = result.data.sort(
                        (a: PortalCustomerItem, b: PortalCustomerItem) =>
                            a.name < b.name ? -1 : 1
                    )
                    if (!response) return
                    setProducersList(response.items)
                    setFilteredProducersList(response.items)
                } else {
                    const errorMessages = result.data.message
                    console.log(errorMessages)
                }
                setLoading(false)
            })
            .catch(error => {
                console.log(error)
                setLoading(false)
            })
    }

    const doSearch = (
        searchTerm: string,
        portalCustomerListItems: PortalCustomerItem[]
    ) => {
        if (searchTerm && searchTerm != '') {
            const searchTermLower = searchTerm.toLowerCase()
            const filtered = filter(
                portalCustomerListItems,
                item =>
                    includes(item.name.toLowerCase(), searchTermLower) ||
                    includes(item.orgNo, searchTermLower) ||
                    includes(item.vatNo, searchTermLower)
            )
            setFilteredProducersList(filtered || [])
        } else {
            setFilteredProducersList(portalCustomerListItems || [])
        }
    }

    const onSearch = (searchTerm: string) => {
        doSearch(searchTerm, producersList)
    }

    useEffect(() => {
        fetchConnectedProducersList()
    }, [])

    return (
        <div className={'connected-producers-list'}>
            <ConnectedProducersListHeader
                onSearch={onSearch}
                heading={props.heading}
            />
            {loading ? (
                <LoadingIndicator customMargins="5rem 0"/>
            ) : (
                <ProducersList
                    items={filteredProducersList}
                    isSearched={isSearched}
                />
            )}
        </div>
    )
}

export default ConnectedProducersList
